module.exports = __webpack_public_path__ + "img/carousel-vet-3.542ae47a.jpg";